import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
import CasinoCurrencyModal from './sub_components/casinoCurrencyModal';
import { casinoCurrencyList } from '../configs/casinoCurrencyList';
import * as authUtil from "../util/auth.util";
let oid = OPERATOR_ID.toLowerCase()

class EzugiMac extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            showPopup: false,
            operator: OPERATOR_ID,
            gameType: "new",
            gameCategory: "All",
            openGame: false,
            evolutionSrc: '',
            link: "",
            loader: true,
            offlineGameListIDs: [ "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12" ]
        };
    }
    componentDidMount() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        if ((!!accData && Object.keys(accData).length > 0)) {
            this.setState({ showPopup: casinoCurrencyList["EZUGIMAC88"].currencyEquals === '1' ? false : true }, () => {
                const operator = this.state.operator
                let token = JSON.parse(localStorage.getItem('userAuthDetail'))
                let rl = token?.role
                token = !!token ? token.token : null
                if (!!operator && !!token && rl !== 'DemoClient') {
                    window.localStorage.setItem("operator", operator);
                    window.localStorage.setItem("token", token);
                    // GamesService.getMac88Casino().then((res) => {
                    //     if (!!res && !!res.data && res.data.length > 0) {
                    //         this.setState({ games: res.data })
                    //     }
                    //     this.setState({ loader: false })
                    // })
                    this.getIndividualGame("EzugiLDLobby.201");
                }
            });
        }
    }
    getIndividualGame = async (gameId) => {
        this.setState({ isLoading: true });
        const gameRes = await GamesService.getIndividualGame(gameId);
        const gameData = gameRes.data;
        if (!gameData && !gameRes.isSuccess && !!gameRes?.exception?.message) {
            this.props.MySwal.fire({
                title: 'Error',
                text: `${gameRes?.exception?.code} ${gameRes?.exception?.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            })
            this.setState({ loader: false });
            // this.setState({ showPopup: true, popupMessage: gameRes.message, loader: false });
        }
        if (!!gameData && !!gameData.url) {
            this.setState({ openGame: true, link: gameData.url, loader: false })
        }
    }
    hideCurrencyPopup() {
        this.setState({ showPopup: false });
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    <div className="col-center1 markets">
                        <section>
                            {!(!!accData && Object.keys(accData).length > 0) &&
                                <div className="sub_path center-box"><p>Casino</p></div>
                            }
                            <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                                {(!!profData && profData.role !== 'DemoClient') && (!!accData && Object.keys(accData).length > 0) ?
                                    <>
                                        {this.state.openGame !== true ? <>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                        <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                                    </div>
                                                </div>
                                            </div>
                                            {!this.state.loader &&
                                                <>
                                                    <div className="row">
                                                        <div className="text-center">
                                                            {<img alt="" src={BASE_IMAGE_PATH + "/casino/banner/Indian-poker-banner.jpg"} ></img>}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4 mb-2 featured-game1">
                                                        {
                                                            this.state.games.map((game) => (
                                                                <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                                    <div className="img-pos">
                                                                        <img alt="" src={BASE_IMAGE_PATH + `/casino/img/${game.gameId}.png`} className="img-fluid" />
                                                                        {
                                                                            game.isNew &&
                                                                            <div className="newgame"></div>
                                                                        }
                                                                        {
                                                                            game.isPopular &&
                                                                            <div className="hotgame"></div>
                                                                        }
                                                                    </div>
                                                                    <div className="text-center game-title-main">{game.gameName}</div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                </>}
                                        </> :
                                            <div className="row">
                                                <div onClick={() => { this.setState({ openGame: false, isLoading: false }) }} style={{ position: "absolute", width: "30px", textAlign: "center" }}><i className="fa fa-times popup-cross"></i></div>
                                                <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                                            </div>
                                        }
                                    </>
                                    :
                                    <>
                                        <div className='row mt-4 mb-2 featured-game1 casino-game livecasino-container-login'>
                                        {
                                            !!this.state.offlineGameListIDs && this.state.offlineGameListIDs.length > 0 && this.state.offlineGameListIDs.map((itm)=>{
                                                return(
                                                    <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 livecasino-item slots__item" onClick={() => { if (!!profData && profData.role === 'DemoClient') { this.props.notify("Login with real Id.", "error") } else { authUtil.clickOpenLoginPopup() } }}>
                                                        <div className="img-pos">
                                                            <img alt="" src={BASE_IMAGE_PATH + `/casino/img/ezugi${itm}.webp`} className="img-fluid" />
                                                        </div>
                                                        <div className="slots__bg-login">
                                                            <div className="slots__overlay">
                                                                <div className="slots__favorite"></div>
                                                                <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                    </>
                                }
                            </div>
                        </section>
                    </div>
                    {this.state.showPopup && (!!accData && Object.keys(accData).length > 0) && <>
                        <CasinoCurrencyModal currencyEquals={casinoCurrencyList["EZUGIMAC88"].currencyEquals} fileNM={"casinopoint"} hidePopup={() => { this.hideCurrencyPopup() }} />
                    </>}
                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(EzugiMac);